import { useState } from 'react';
import { Icon } from '../../../shared/Icon';
import { speakNorwegian } from '../../../shared/speech';
import type { ExercisePluginProps } from '../types';
import { text } from '../contentFields';

const scores = { again: 0.1, hard: 0.45, good: 0.8, easy: 1 } as const;
type Rating = keyof typeof scores;

export function RetrievalExercise({ exercise, onComplete, showToast }: ExercisePluginProps) {
  const [revealed, setRevealed] = useState(false);
  const [saving, setSaving] = useState(false);
  const answer = text(exercise.content, 'answer');
  const fullAnswer = text(exercise.content, 'fullAnswer', answer);
  const sentence = text(exercise.content, 'sentence', fullAnswer).replace('{{answer}}', '_____');
  const verbPhrase = exercise.content.verbPhrase === true;

  async function rate(rating: Rating) {
    setSaving(true);
    await onComplete({
      response: { rating },
      result: { rating, itemId: exercise.targets[0] },
      evidence: [{ itemId: exercise.targets[0], dimension: 'recalled', value: scores[rating] }],
      repeat: rating === 'again'
    });
  }

  function listen() {
    if (!speakNorwegian(fullAnswer)) showToast('Lyd er ikke tilgjengelig i denne nettleseren.');
  }

  return <>
    <p className="exercise-kicker">{verbPhrase ? 'HENT FRAM HELE UTTRYKKET' : 'HENT FRAM IGJEN'}</p>
    <h2 className="exercise-title">{verbPhrase ? 'Hvilken verbfrase passer?' : 'Hent fram ordet.'}</h2>
    <p className="exercise-intro">{text(exercise.content, 'instruction', 'Si hele setningen før du viser svaret.')}</p>
    <div className={`flashcard recall-card ${revealed ? 'revealed' : ''}`}>
      <div className="recall-card-inner">
        <small>SITUASJON</small><p className="recall-context">{text(exercise.content, 'situation')}</p>
        <span className="recall-cue-label">{verbPhrase ? 'UTTRYKKET BETYR' : 'ORDET BETYR'}</span><strong className="recall-cue">“{text(exercise.content, 'meaningCue')}”</strong>
        {!verbPhrase && <><span className="recall-sentence-label">FULLFØR SETNINGEN</span><p className="recall-sentence">{sentence}</p></>}
        <div className="flash-answer"><small>SVAR</small><b>{answer}</b><span>{fullAnswer}</span><button className="flash-listen" onClick={listen}><Icon name="volume" /> Hør hele setningen</button></div>
      </div>
    </div>
    {!revealed && <button className="reveal-button" onClick={() => setRevealed(true)}>Vis svaret</button>}
    {revealed && <div className="rating-row">
      <button disabled={saving} onClick={() => rate('again')}>Igjen<br /><small>1 min</small></button>
      <button disabled={saving} onClick={() => rate('hard')}>Vanskelig<br /><small>1 dag</small></button>
      <button disabled={saving} onClick={() => rate('good')}>Bra<br /><small>minst 3 dager</small></button>
      <button disabled={saving} onClick={() => rate('easy')}>Lett<br /><small>minst 7 dager</small></button>
    </div>}
  </>;
}
